import { MapMarkerMinusOutlineIcon } from './MapMarkerMinusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 21A7EBBF-D884-4A4E-B722-01600B89FFB4
 * name map-marker-minus-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-minus-outline.svg
 * tags
 * - Geographic Information System 
 * - Navigation 
 */
export const LocationMinusOutlineIcon = MapMarkerMinusOutlineIcon;
export default LocationMinusOutlineIcon